export default "__VITE_ASSET__DZ3ZrVvM__"